const border = {
    '1px': `1px solid deeppink`,
};

export default border
